import type { UserRecent } from '@/types/domain/core';
import { coreRequestService } from '@/api/core';

export const usersOwnRecent = (headers?: Record<string, string>) => coreRequestService<UserRecent[]>({
    url: '/users/own/recent',
    method: 'GET',
    headers
});
